import * as React from "react";
import { useNavigate, useSearchParams } from "react-router";
import { Loading } from "@kaladel/react/Components";
import { useApp } from "AppContext";
import { useApiClient } from "Contexts/ApiClientContext";

export const Return: React.FC = () => {
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const { api, apiCall } = useApiClient();
    const { refreshSession } = useApp();

    if (!searchParams || !searchParams.has("tkn")) navigate("/");

    const attemptLogin = async () => {
        console.log("Posting new session");
        const response = await apiCall(() => api.session.post(
            {
                queryParameters:
                {
                    token: searchParams.get("tkn")!
                }
            }
        ));

        if (response.kind === "success") {
            refreshSession();
            if (searchParams.has("returnPath")) {
                navigate(searchParams.get("returnPath")!);
            }
            else {
                navigate("/home");
            }
        }
    };

    React.useEffect(() => {
        attemptLogin();
    }, []);

    return (
        <div>
            <Loading />
        </div>
    );
};